import { Page } from '@/core/architecture'

import { StoreUserInfoTemplate } from './template'
import { useViewModel } from './viewModel'

export const StoreUserInfo: Page = () => {
  const { state, actions } = useViewModel()

  return <StoreUserInfoTemplate state={state} {...actions} />
}
